// usePlaybackEngine.js
import * as VesselUtil from "@/utils/VesselUtil";

export default function usePlaybackEngine(
  objectId,
  points,
  updateFeature,
  sourceType,
  properties = {}
) {
  let prev = null;
  let next = null;
  let latestFeature = null;

  const sortedPoints = [...points].sort((a, b) => a.t - b.t);

  const findSurroundingPoints = t => {
    prev = null;
    next = null;
    for (let i = 0; i < sortedPoints.length - 1; i++) {
      if (sortedPoints[i].t <= t && t <= sortedPoints[i + 1].t) {
        prev = sortedPoints[i];
        next = sortedPoints[i + 1];
        break;
      }
    }
  };

  const interpolate = t => {
    if (!prev || !next) return null;

    const ratio = (t - prev.t) / (next.t - prev.t);
    const lon = prev.lon + (next.lon - prev.lon) * ratio;
    const lat = prev.lat + (next.lat - prev.lat) * ratio;

    const commonProps = {
      objectId,
      t,
      source: sourceType,
    };

    const sourceSpecificProps =
      sourceType === "ais"
        ? {
            icon: VesselUtil.getSymbolIconNameLightWeight(
              parseInt(properties.category),
              prev.v,
              0
            ),
            sog: prev.v,
            cog: prev.h,
            name: properties.nameJp || properties.name,
            heading: prev.h,
            isMyVessel: properties.isMyVessel,
          }
        : {
            icon:
              prev.k === ""
                ? "rg-target-object-safe-default"
                : "rg-vessel-safe",
            sog: prev.sog,
            cog: prev.cog,
            name:
              prev.k !== ""
                ? `Track\n${properties.name}`
                : `Target\n${properties.name}`,
            heading: prev.cog,
            isTrack: prev.k === "",
            lat: prev.lat,
            lon: prev.lon,
            kind: prev.k,
            cameraId: prev.cameraId,
            log: prev.log,
            imgUrl: prev.p && prev.p.length > 0 ? prev.p[0].p : undefined,
            confidence: prev.p && prev.p.length > 0 ? prev.p[0].co : undefined,
            shootingDate: prev.p && prev.p.length > 0 ? prev.p[0].t : undefined,
          };
    return {
      type: "Feature",
      id: `${objectId}_${t}`,
      geometry: {
        type: "Point",
        coordinates: [lon, lat],
      },
      properties: {
        ...commonProps,
        ...sourceSpecificProps,
      },
    };
  };

  const update = t => {
    if (t < sortedPoints[0].t) {
      updateFeature(objectId, null);
      latestFeature = null;
      return;
    }

    findSurroundingPoints(t);
    const feature = interpolate(t);
    if (feature) {
      latestFeature = feature;
      updateFeature(objectId, feature);
    }
  };

  const seek = t => {
    update(t);
  };

  const getLatestFeature = () => latestFeature;

  return { update, seek, getLatestFeature };
}
